import API_BASE_URL from './config';
import React from 'react';
import { Link } from 'react-router-dom';

const RegistrationGuide = () => {
  const pageStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '170px 20px 20px',
    fontFamily: 'Arial, sans-serif',
    color: '#333',
    lineHeight: '1.6'
  };

  const sectionStyle = {
    backgroundColor: '#E6F0FA',
    padding: '20px',
    borderRadius: '10px',
    marginBottom: '20px',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)'
  };

  const headingStyle = {
    color: '#1E88E5',
    fontSize: '2em',
    marginBottom: '15px'
  };

  const subHeadingStyle = {
    color: '#1976D2',
    fontSize: '1.5em',
    margin: '15px 0 10px'
  };

  const linkStyle = {
    color: '#1E88E5',
    textDecoration: 'none',
    fontWeight: 'bold',
    transition: 'color 0.3s'
  };

  const listStyle = {
    margin: '10px 0',
    paddingLeft: '20px'
  };

  const noteStyle = {
    color: '#1E88E5',
    fontStyle: 'italic',
    margin: '10px 0'
  };

  const backgroundContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '20px',
    margin: '15px 0'
  };

  const backgroundImageStyle = {
    width: '200px',
    height: '200px',
    objectFit: 'cover',
    borderRadius: '5px',
    border: '1px solid #90CAF9',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
  };

  const backgroundCaptionStyle = {
    textAlign: 'center',
    fontSize: '0.9em',
    color: '#1976D2',
    marginTop: '5px'
  };

  return (
    <div style={pageStyle}>
      <div style={sectionStyle}>
        <h1 style={headingStyle}>Registration Guide</h1>
        <p>
          Registration is required to participate in the Dog Fanciers Guild. Players must use the provided registration linearts for dogs and staff. 
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={subHeadingStyle}>Dog Registration</h2>

        <p>
          Start by depicting your dog on one of the official linearts from the <Link to="/breeds" style={linkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Accepted Breeds</Link> collection. You may use any available lineart that fits your dog’s breed or character design. To modify the lineart in any way players must use a Lineart Edit Item (see below).
        </p>
        <p>
          Once your dog is colored on the official lines, upload it in full size, (1130px1130px) to a site like DeviantArt or Toyhou.se. You are now ready to submit your dog for registration! You can see a list of your pending dogs on your My Dogs page.  
        </p>
        <p>
          An admin will review your dog to make sure he is formatted correctly, and is within the item modification limitations. Created breeds are checked for authenticity, and then your new dog will show up on your <Link to="/my-dogs" style={linkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>My Dogs</Link> page, ready to play! Your dog will also be added to the public <Link to="/studbook" style={linkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Studbook</Link> for others to admire.
        </p>
        <h3 style={{ color: '#1976D2', fontSize: '1.2em' }}>Registration Eligibility</h3>
        <ul style={listStyle}>
          <li>Any dog can be registered, including mixes and fantasy/created breeds.</li>
          <li>Players must depict characters accurately to preserve their representation.</li>
          <li>Players may only register dogs they own.</li>
          <li>Every player in good standing may register an unlimited number of dogs.</li>
        </ul>
        <h3 style={{ color: '#1976D2', fontSize: '1.2em' }}>Official Breed Linearts</h3>
        <p>
          Official Breed Linearts are required for dog registration. You may not use custom images for your characters. The official linearts, and new breeds, are released over time with no fixed schedule. The Dog Fanciers Guild Linearts are free for all Guild players. Linearts can be shared offsite if accompanied by a link to the <Link to="/" style={linkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Dog Fanciers Guild</Link>. They <strong>may not</strong> be used for adoptables, imports, or other games.
        </p>
        
        <h3 style={{ color: '#1976D2', fontSize: '1.2em' }}>Editing Registration Linearts</h3>
        <p>
          Linearts may only be edited by using one of the Lineart Edit items available in the <Link to="/item-shop" style={linkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Item Shop</Link>. You must own the item in your inventory at the time you submit the dog for admin review or your registration may be commented for a correction, or denied, requiring resubmission. See the <Link to="/guides/lineart-regulations" style={linkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Lineart Edit Regulations</Link> for detailed rules and descriptions of the what edits can be made to the official linearts.
        </p>
        <h3 style={{ color: '#1976D2', fontSize: '1.2em' }}>Registration Image Backgrounds</h3>
        <p>
          There are four free backgrounds provided by the guild for players to use (those are called, Ballyard, Grassfield, Training Flags, and Cornstalk Road). For customization options players can use a custom background item from their inventory OR they may register a reusable background for their kennel through the <Link to="/register-kennel" style={linkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Kennel Registration</Link> program (described below).
        </p>
        <div style={backgroundContainerStyle}>
          <div>
            <img
              src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e278b58f-e271-405b-8060-c4679e13d416/djax4sm-bd720196-1fe3-4b72-868c-7516470f74ab.png/v1/fill/w_894,h_894,q_70,strp/ball_yard_by_dogfanciersguild_djax4sm-pre.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTI1MCIsInBhdGgiOiJcL2ZcL2UyNzhiNThmLWUyNzEtNDA1Yi04MDYwLWM0Njc5ZTEzZDQxNlwvZGpheDRzbS1iZDcyMDE5Ni0xZmUzLTRiNzItODY4Yy03NTE2NDcwZjc0YWIucG5nIiwid2lkdGgiOiI8PTEyNTAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.SZzxXPXhyaKnng3WqlOM9r9z2Sr8BkIbhzSd-tWqrTg"
              alt="Ballyard Background"
              style={backgroundImageStyle}
            />
            <p style={backgroundCaptionStyle}>Ballyard</p>
          </div>
          <div>
            <img
              src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e278b58f-e271-405b-8060-c4679e13d416/djfaav3-065faecb-63c1-42ae-9ce5-0cf2e2c35167.png/v1/fill/w_894,h_894,q_70,strp/greenpatch_bg_by_dogfanciersguild_djfaav3-pre.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTAwIiwicGF0aCI6IlwvZlwvZTI3OGI1OGYtZTI3MS00MDViLTgwNjAtYzQ2NzllMTNkNDE2XC9kamZhYXYzLTA2NWZhZWNiLTYzYzEtNDJhZS05Y2U1LTBjZjJlMmMzNTE2Ny5wbmciLCJ3aWR0aCI6Ijw9OTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.oiwRflZAv4ZzB2J4Y8lc9yPryf3kN_Q9IlGUCMmiWI4"
              alt="Grassfield Background"
              style={backgroundImageStyle}
            />
            <p style={backgroundCaptionStyle}>Grassfield</p>
          </div>
          <div>
            <img
              src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e278b58f-e271-405b-8060-c4679e13d416/djax50p-5b7b6d9e-046b-46c1-9056-a984f575e651.png/v1/fill/w_894,h_894,q_70,strp/cone_flags_by_dogfanciersguild_djax50p-pre.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTAwIiwicGF0aCI6IlwvZlwvZTI3OGI1OGYtZTI3MS00MDViLTgwNjAtYzQ2NzllMTNkNDE2XC9kamF4NTBwLTViN2I2ZDllLTA0NmItNDZjMS05MDU2LWE5ODRmNTc1ZTY1MS5wbmciLCJ3aWR0aCI6Ijw9OTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.w4-b4y7yV881Erh4rfZQcN3uhSKISsWr2ZqvkjIb0xs"
              alt="Training Flags Background"
              style={backgroundImageStyle}
            />
            <p style={backgroundCaptionStyle}>Training Flags</p>
          </div>
          <div>
            <img
              src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e278b58f-e271-405b-8060-c4679e13d416/djax514-205331e7-e4c6-4db6-be23-4c23d7e198f4.png/v1/fill/w_894,h_894/corn_field_fence_by_dogfanciersguild_djax514-pre.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTI1MCIsInBhdGgiOiJcL2ZcL2UyNzhiNThmLWUyNzEtNDA1Yi04MDYwLWM0Njc5ZTEzZDQxNlwvZGpheDUxNC0yMDUzMzFlNy1lNGM2LTRkYjYtYmUyMy00YzIzZDdlMTk4ZjQucG5nIiwid2lkdGgiOiI8PTEyNTAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.TepFaS-pAQG0CQMDP9pPAyqdNzxN6XOw2HTzzf9qR2A"
              alt="Cornfield Fence"
              style={backgroundImageStyle}
            />
            <p style={backgroundCaptionStyle}>Cornfield Fence</p>
          </div>
        </div>
      </div>

      <div style={sectionStyle}>
        <h2 style={subHeadingStyle}>Staff Registration</h2>
        <p>
          <strong>Staff registration is required to earn DFG$</strong>. Registering a staff member lets them appear in the game and unlocks hobbies and professions. You don’t need to have a kennel to register staff but you can assign staff to kennels.
        </p>
        <p>
          Depict your staff on the provided lineart (pinned in Discord "help" for testing). Once your artwork is ready, upload it to a site like DeviantArt or Toyhou.se. Then, head to the <Link to="/register-staff" style={linkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Register a Staff Member</Link> page to submit your artwork and details for admin approval.
        </p>
        <p>
          After an admin approves your staff member, they’ll show up on your <Link to="/my-staff" style={linkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>My Staff</Link> page, ready to play! You can register staff without a kennel, but associating them with a kennel adds them to its <Link to="/kennel-registry" style={linkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Kennel Registry</Link> profile.
        </p>
        <h3 style={{ color: '#1976D2', fontSize: '1.2em' }}>Registration Eligibility</h3>
        <ul style={listStyle}>
          <li>Any character can be registered as staff, including fantasy or original designs.</li>
          <li>Players must depict staff accurately to preserve their representation.</li>
          <li>Players may only register staff they own.</li>
          <li>Every player in good standing may register an unlimited number of staff.</li>
        </ul>
        <h3 style={{ color: '#1976D2', fontSize: '1.2em' }}>Official Staff Linearts</h3>
        <p>
          Official Staff Linearts are required for registration and come in male and female options only. They are available as .psd files. The staff files include some customization items like hairstyles, facial hair, and clothing designed to fit each lineart. Players can color the entire template in any way without items. Staff templates are free for all Guild players in good standing with the guild and, released over time with no fixed schedule. They can be shared offsite if accompanied by a link to the <Link to="/" style={linkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Dog Fanciers Guild</Link>. They <strong>may not</strong> be used for adoptables, imports, or any other games.
        </p>
        <p>
          Download linearts from our <a href="https://drive.google.com/drive/folders/1nOrRIzuLNZwykRC-NkQjiI4ALVqaUPW4?usp=drive_link" target="_blank" rel="noopener noreferrer" style={linkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Google Drive</a>. On-site downloads are coming soon!
        </p>
        <h3 style={{ color: '#1976D2', fontSize: '1.2em' }}>Editing Registration Linearts</h3>
        <p>
          The body, hairstyles, facial hair, or clothing lines of staff linearts <strong>cannot be edited</strong> without a Lineart Edit Item or Custom Clothing Item from the <Link to="/item-shop" style={linkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Item Shop</Link>. You must have the item in your inventory when you submit the staff for admin review, or your registration may be commented for correction or denied requiring resubmission. Coloring defaults (hair, skin, clothes, facial hair) is free and unlimited, they can be recolored in any way. Staff can earn emotes and outfits through gameplay. These must be in your inventory at the time you submit your staff for review as well.
        </p>
        <p style={noteStyle}>
          See the <Link to="/guides/lineart-regulations" style={linkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Lineart Edit Regulations</Link> for detailed rules on allowed edits, including custom clothing options.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={subHeadingStyle}>Kennel Registration</h2>
        <p>
          <strong>Kennel registration is optional</strong> but allows you to use custom backgrounds for your dog registrations and create a kennel profile. Register using the <Link to="/register-kennel" style={linkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Kennel Registration</Link> system. Each kennel has a profile in the <Link to="/kennel-registry" style={linkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Kennel Registry</Link>, listing its name, prefix/suffix, owner, blank background image, and associated dogs and staff. Kennels are not required to play the game.
        </p>
        <h3 style={{ color: '#1976D2', fontSize: '1.2em' }}>Registration Eligibility</h3>
        <ul style={listStyle}>
          <li>Any player in good standing may register unlimited kennels.</li>
        </ul>
        <h3 style={{ color: '#1976D2', fontSize: '1.2em' }}>Kennel Background Regulations</h3>
        <ul style={listStyle}>
          <li>Backgrounds must be saved as a flat .PNG file</li>
          <li>1130px wide x 1130px high.</li>
        </ul>
      </div>
    </div>
  );
};

export default RegistrationGuide;